import dayjs from 'dayjs';
import { ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { useAppSelector } from 'store/hooks';
import { useFlags } from 'launchdarkly-react-client-sdk';

import Avatar from '../components/avatar';
import Footer, {
  ExpandHistoryButton,
  FooterActions,
  History,
  Item,
  Description,
  PersonInfo
} from '../components/footer/footer';

type Props = {
  children: ReactNode;
  clientId?: string;
};

const OtherFooter = ({ children, clientId }: Props) => {
  const { clientId: routeClientId = '' } = useParams();
  const resolvedClientId = clientId ?? routeClientId;
  const { enableDateTimeUpdates } = useFlags();
  const otherScreenerHistory = useAppSelector(
    (state) => state.screener[resolvedClientId]?.otherScreenerHistory
  );

  return (
    <Footer>
      <FooterActions>
        {otherScreenerHistory && otherScreenerHistory?.length > 0 ? (
          <ExpandHistoryButton />
        ) : (
          <button style={{ visibility: 'hidden' }}></button>
        )}
        {children}
      </FooterActions>
      <History>
        {otherScreenerHistory?.map((historyItem) => (
          <Item key={historyItem.id}>
            <Description>
              Screened on:{' '}
              <span>
                {enableDateTimeUpdates && historyItem.dateAndTimeOfScreening
                  ? dayjs(historyItem.dateAndTimeOfScreening).format('M/D/YYYY h:mm a')
                  : historyItem.dateOfScreening
                  ? dayjs(historyItem.dateOfScreening).format('M/D/YYYY')
                  : 'Unknown'}
              </span>
            </Description>
            <PersonInfo>
              <Avatar imageUrl={historyItem.author.profileImageKey} />
              <p>{historyItem.author.name}</p>
            </PersonInfo>
          </Item>
        ))}
      </History>
    </Footer>
  );
};

export default OtherFooter;
